import { MiddlewareAPI, Middleware } from "redux";
import { TranslationsActionType } from "redux/actions/TranslationActions";
import { Translations } from "models/Translations";
import { Language } from "models/ProfileSettings";
require("../../assets/language/de.lang");
require("../../assets/language/en.lang");

let requested: Language | undefined;

export const loadJson: Middleware = ({
    dispatch
}: MiddlewareAPI) => next => (action: any) => {
    if (!action.type || action.type !== TranslationsActionType.LOAD_TRANSLATIONS) {
        return next(action);
    }
    const language: Language = action.language;
    if (requested === language) {
        return;
    }
    requested = language;
    fetch('/lang/' + language.toLowerCase() + '.lang',
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    ).then(function (response) {
        return response.json();
    }).then((translations) =>  {
        if (requested !== language) {
            return;
        }
        dispatch({
            type: TranslationsActionType.LOAD_TRANSLATIONS_DONE,
            translations: translations as Translations
        })
    }).catch(() => {
        if (requested === language) {
            requested = undefined;
        }
    });
};
